// extracted by mini-css-extract-plugin
export var closeButton = "_pt-2";
export var closeButtonIcon = "_pt-3";
export var lightboxContent = "_pt-1";
export var lightboxOverlay = "_pt-0";